import Simple from './Simple/Simple';

const templates = {
  Simple,
};

export default templates;